var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExecutive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.5,203c-1.6-0.4-3.1-1-4.7-1.3l-5.9-1.2l-20.9,15.7l22.6,18L236.5,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.8,296C270,280.1,264,261.1,264,241.4c0-7.9,1-15.5,2.8-22.9c-4.7-3.9-9.8-7.3-15.2-10l-15.2,53.2L213,243 l-4.2,6.4L222,296L280.8,296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194,256H190l-11.4,40h26.8L194,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,90.2c3.6-1.4,7.4-2.2,11.5-2.2h0.1c0.7-13.3,8.3-25.1,20.3-31.2l3.9-2l43.8,26.3l-8.2,13.7l-35.8-21.5 c-5,3.9-8.1,10-8.1,16.5V144c0,13.2,10.8,24,24,24h32c13.2,0,24-10.8,24-24V88h16c4.7,0,9,1,13,2.8l1.5-6c1-3.9,1.5-7.9,1.5-11.9 c0-27-22-49-49-49h-53.1c-8,0-15.2,4.4-18.7,11.6l-1.5,3l-6.7,2.2c-8.9,3-14.9,11.3-14.9,20.7c0,1.2,0.1,2.4,0.3,3.6L124.5,90.2z  M222.3,133.3c-5.8,11.6-17.4,18.7-30.3,18.7h-24v-16h24c6.8,0,13-3.8,16-9.9l0.8-1.7l14.3,7.2L222.3,133.3z M196.1,41.1l40,24 l-8.2,13.7l-40-24L196.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248,104v32c8.8,0,16-7.2,16-16S256.8,104,248,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136,136v-32c-8.8,0-16,7.2-16,16S127.2,136,136,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.1,200.5l-5.9,1.2c-1.6,0.3-3.2,0.8-4.7,1.2l9,31.4l22.6-18L158.1,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248,152h-0.8c-2.3,11.4-9.5,21-19.2,26.6l2.1,6.4l4.8,1c13.5,2.7,26.2,8.4,37.3,16.4 c14.9-33.9,48.6-57.7,87.8-58.3V88h-81.8c-0.1,0.2-0.1,0.5-0.1,0.8l-3.4,13.6c3.4,5.1,5.3,11.1,5.3,17.6 C280,137.6,265.6,152,248,152L248,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.4,208.5C105.8,221.7,88,249.2,88,280v16h74l13.3-46.6l-4.2-6.4l-23.4,18.8L132.4,208.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.8,183.6c-1.6,0.2-3.1,0.4-4.8,0.4h-32c-1.6,0-3.2-0.3-4.7-0.5l-1.8,5.5L192,206l22.6-16.9L212.8,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.6,233l4.7,7h7.4l4.7-7l-8.4-6.7L183.6,233z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344,416v-8v-16v-16v-19.5c0-5.2-2.5-10.1-6.8-13.1l-31.6-22.1c-4-2.8-7.6-6-11.1-9.3H72v-32 c0-45.5,32.4-85,77-94l4.8-1l2.2-6.6c-9.7-5.6-16.9-15.1-19.3-26.5H136c-17.6,0-32-14.4-32-32c0-7,2.3-13.4,6.1-18.7L107.9,88H24 v400h336v-40.2C350.3,440.5,344,429,344,416z M152,328h64v16h-64V328z M72,328h64v16H72V328z M88,472H72v-16h16V472z M120,472h-16 v-16h16V472z M152,472h-16v-16h16V472z M312,440H72v-16h240V440z M312,408H72v-16h240V408z M312,376H72v-16h240V376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360,392h48v16h-48V392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384,440c10.4,0,19.3-6.7,22.6-16h-45.3C364.7,433.3,373.6,440,384,440L384,440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.4,249.7L384,235.3l-14.4,14.4l-14.8-7.4l-8.9,13.4L376,296v-32h16v32l30.2-40.3l-8.9-13.4L398.4,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.6,160h-45.1c-44.9,0-81.4,36.5-81.4,81.4c0,26.6,13,51.5,34.7,66.7l31.6,22.1c8.5,6,13.6,15.8,13.6,26.2 V376h48v-19.5c0-10.4,5.1-20.2,13.6-26.2l31.6-22.1C475,292.9,488,268,488,241.4C488,196.5,451.5,160,406.6,160z M392,322.7V360 h-16v-37.3l-49.8-66.4l23.1-34.6l17.2,8.6l17.6-17.6l17.6,17.6l17.2-8.6l23.1,34.6L392,322.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutive);
export default __webpack_public_path__ + "static/media/executive.0633c68140dfa3635b8a7c93e810234e.svg";
export { ForwardRef as ReactComponent };